import React, { useState, useEffect } from "react";
import { Info, Loader2, AlertCircle } from "lucide-react";

const SystemInformation = () => {
  const [systemInfo, setSystemInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSystemInfo = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch("/api/security/get_sysinfo");

      if (!response.ok) {
        throw new Error('Failed to fetch system information');
      }

      const data = await response.json();
      setSystemInfo(data);
    } catch (err) {
      console.error('Error fetching system information:', err);
      setError("Failed to fetch system information. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSystemInfo();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
          <Loader2 style={{ width: '48px', height: '48px', color: 'var(--cares-blue)', animation: 'spin 1s linear infinite' }} />
        </div>
      </div>
    );
  }

  if (error && !systemInfo) {
    return (
      <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        {/* Page Header - Title removed to avoid duplication with Dashboard Header */}
        <div style={{
          background: 'color-mix(in srgb, var(--cares-orange) 22%, var(--cares-surface-card))',
          borderLeft: '4px solid var(--cares-orange)',
          borderRadius: '0 8px 8px 0',
          padding: '16px',
          display: 'flex',
          gap: '12px'
        }}>
          <AlertCircle style={{ width: '20px', height: '20px', color: 'var(--cares-orange)', flexShrink: 0 }} />
          <p style={{ fontSize: '14px', color: 'var(--cares-orange)', margin: 0 }}>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Page Header - Title removed to avoid duplication with Dashboard Header */}

      {systemInfo && (
        <div style={{
          background: 'var(--cares-surface-card)',
          borderRadius: '12px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          overflow: 'hidden'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--cares-surface-board)', borderBottom: '2px solid var(--cares-line-card)' }}>
                <th style={{
                  padding: '16px 24px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: 'var(--cares-text-label)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  Field
                </th>
                <th style={{
                  padding: '16px 24px',
                  textAlign: 'left',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: 'var(--cares-text-label)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  Value
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(systemInfo).map(([field, value], index, array) => (
                <tr
                  key={field}
                  style={{
                    borderBottom: index < array.length - 1 ? '1px solid var(--cares-line-card)' : 'none',
                    transition: 'background 0.2s'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.background = 'var(--cares-surface-board)'}
                  onMouseOut={(e) => e.currentTarget.style.background = 'var(--cares-surface-card)'}
                >
                  <td style={{ padding: '16px 24px' }}>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: 'var(--cares-text-1)' }}>{field}</div>
                  </td>
                  <td style={{ padding: '16px 24px' }}>
                    <div style={{
                      fontSize: '14px',
                      fontWeight: field === "Status" ? '600' : '400',
                      color: field === "Status" && value === "Active" ? 'var(--cares-green)' :
                             field === "Status" && value !== "Active" ? 'var(--cares-orange)' :
                             'var(--cares-text-3)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      {field === "Status" && (
                        <span style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          background: value === "Active" ? 'var(--cares-green)' : 'var(--cares-orange)',
                          display: 'inline-block'
                        }}></span>
                      )}
                      {value}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SystemInformation;